import { create } from 'zustand';

const useManagerApprovalStore = create((set) => ({
  // List view state
  powerappsWithApprovals: [],
  archivedApprovals: [],
  totalPendingPowerapps: 0,
  totalPendingApprovals: 0,
  totalArchivedPowerapps: 0,
  totalArchivedApprovals: 0,
  approvalSummary: { approved: 0, declined: 0 },
  
  // History view state
  approvalHistory: [],
  currentPage: 1,
  pageCount: 1,
  totalItems: 0,
  itemsPerPage: 20,
  
  // Stats
  approvalStats: {},
  
  // Powerapp specific
  powerappApprovals: [],
  approvalStatus: {},
  
  // Common
  organizationId: null,
  searchQuery: '',
  sortBy: 'manager_approval_created_at',
  sortDirection: 'DESC',
  loading: false,
  selectedPowerappId: null,
  selectedPowerapp: null,
  
  // Actions
  setPowerappsWithApprovals: (approvals) => set({ powerappsWithApprovals: approvals }),
  setArchivedApprovals: (approvals) => set({ archivedApprovals: approvals }),
  setTotalPendingPowerapps: (total) => set({ totalPendingPowerapps: total }),
  setTotalPendingApprovals: (total) => set({ totalPendingApprovals: total }),
  setTotalArchivedPowerapps: (total) => set({ totalArchivedPowerapps: total }),
  setTotalArchivedApprovals: (total) => set({ totalArchivedApprovals: total }),
  setApprovalSummary: (summary) => set({ approvalSummary: summary }),
  
  setApprovalHistory: (history) => set({ approvalHistory: history }),
  setCurrentPage: (page) => set({ currentPage: page }),
  setPageCount: (count) => set({ pageCount: count }),
  setTotalItems: (total) => set({ totalItems: total }),
  setItemsPerPage: (perPage) => set({ itemsPerPage: perPage }),
  
  setApprovalStats: (stats) => set({ approvalStats: stats }),
  
  setOrganizationId: (id) => set({ organizationId: id }),
  setSearchQuery: (query) => set({ searchQuery: query }),
  setSortBy: (field) => set({ sortBy: field }),
  setSortDirection: (direction) => set({ sortDirection: direction }),
  setLoading: (isLoading) => set({ loading: isLoading }),
  setSelectedPowerappId: (id) => set({ selectedPowerappId: id }),
  setSelectedPowerapp: (powerapp) => set({ selectedPowerapp: powerapp }),
  setPowerappApprovals: (approvals) => set({ powerappApprovals: approvals }),
  setApprovalStatus: (status) => set({ approvalStatus: status }),
  
  // Reset states
  resetListState: () => set({
    powerappsWithApprovals: [],
    archivedApprovals: [],
    totalPendingPowerapps: 0,
    totalPendingApprovals: 0,
    totalArchivedPowerapps: 0,
    totalArchivedApprovals: 0,
    approvalSummary: { approved: 0, declined: 0 },
    selectedPowerappId: null,
    selectedPowerapp: null,
    powerappApprovals: [],
    approvalStatus: {},
  }),
  
  resetHistoryState: () => set({
    approvalHistory: [],
    currentPage: 1,
    pageCount: 1,
    totalItems: 0,
    itemsPerPage: 20,
  }),
}));

export default useManagerApprovalStore;
